import { shuffle } from 'lodash';
import waja from 'waja';
import bus from 'eventbus';
import store from 'datastore';

let cachedCategoryHighlights = null;

export function updateCategoryHighlights (id, callback) {
	if (cachedCategoryHighlights && cachedCategoryHighlights.categoryId === id) {
		// Vi behöver inte hämta samma highlights om och om igen så vi har en primitiv cache här.
		// Trots browsercache på själva endpointen kan det ta över 100ms att läsa från disk cache, medan denna metod i princip går omedelbart.
		// Det blir en märkbar skillnad i hur fort takeovern uppdateras när man bläddrar mellan produkter i samma kategori
		bus.$emit('takeover:update', rollXHighlights(1, cachedCategoryHighlights.takeovers));
		if (callback) {
			callback(rollXHighlights(1, cachedCategoryHighlights.banners));
		}
		return;
	}

	waja.abort('category-highlights');
	waja.get('highlight/' + store.getters['i18n/regionCode'] + '/category/' + id)
		.name('category-highlights')
		.useCdn(true)
		.on('success', res => {
			cachedCategoryHighlights = {
				categoryId: id,
				takeovers: res.data.takeovers,
				banners: res.data.banners,
			};
			bus.$emit('takeover:update', rollXHighlights(1, cachedCategoryHighlights.takeovers));
			if (callback) {
				callback(rollXHighlights(1, cachedCategoryHighlights.banners));
			}
		}).go();
};


/*
* returns an array with <count> highlights (or the highlight object/null if count is 1 or 0)
* randomization is weighted by the highlight displays priority value.
* higher priority means higher odds of not only being displayed, but also being displayed earlier
*
* optional parameter exclusionList: add all the resulting highlights to this array
* if a highlight exists within the passed array, it's priority will be dramatically decreased
* use this to prevent the same displays from being shown first in multiple locations
*/
function rollXHighlights (count, highlights, exclusionList = []) {
	if (! highlights) {
		return count <= 1 ? null : [];
	}
	const sortedHighlights = highlights.slice(0).sort((a, b) => {
		return b.priority - a.priority;
	});
	let totalPriority = 0;
	for (const hl of sortedHighlights) {
		if (exclusionList.includes(hl.highlightId)) {
			hl.priority = 0.0001;
		}
		totalPriority += hl.priority;
	}
	const selected = [];

	outer:
	for (let i = 0; i < count; ++i) {
		let roll = Math.random() * totalPriority;
		for (const j in sortedHighlights) {
			const hl = sortedHighlights[j];
			const priority = hl.priority;
			if (roll <= priority) {
				exclusionList.push(hl.highlightId);
				selected.push(hl);
				sortedHighlights.splice(j, 1);
				totalPriority -= priority;
				continue outer;
			}
			roll -= priority;
		}
	}

	if (count <= 1) {
		if (selected.length > 0) {
			return selected[0];
		} else {
			return null;
		}
	}
	return selected;
}
export { rollXHighlights };

function rollXComponents (count, components) {
	if (! components || components.length === 0) {
		return count <= 1 ? null : [];
	} else if ( components.length === 1) {
		return components;
	}
	const sortedComponents = components.slice(0).sort((a, b) => {
		return b.displays[0].priority - a.displays[0].priority;
	});

	let max = sortedComponents[0].displays[0].priority;
	sortedComponents.forEach(hl => {
		const m = hl.displays[0].priority;
		max = (m > max) ? m : max;
	});
	const filteredComponents = [];
	let cloneCount = count;

	const prioritySteps = [10000,5,4,3,2.5,2,1,0.5,0.0001];

	prioritySteps.forEach(i => {
		if (i > max) {
			return;
		}

		let components = sortedComponents.filter( c => {
			if(c && c.displays) {
				return c.displays[0].priority == i;
			}
		});
		if (components.length <= cloneCount) {
			cloneCount -= components.length;
			components = shuffle(components);
			filteredComponents.push(...components);
		} else if (cloneCount > 0) {
			components = shuffle(components);
			for (let j = 0; j < cloneCount; j++) {
				filteredComponents.push(components[j]);
			}
		}
	});
	if (count <= 1) {
		if (filteredComponents.length > 0) {
			return filteredComponents;
		} else {
			return null;
		}
	}
	return filteredComponents;
}
export { rollXComponents };

